import Language from '../language';

export class KPI_Translation {
  kpiId: number;

  languageId: number;

  name: string;

  description?: string;

  instruction?: string;

  expectedResult?: string;

  lang?: Language;

  constructor() {
    this.kpiId = -1;
    this.languageId = -1;
    this.name = '';
  }
}
